import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@teliads/components/loader';
defineCustomElements();
export const TeliaAccordion = createReactComponent('telia-accordion');
export const TeliaAccordionItem = createReactComponent('telia-accordion-item');
export const TeliaAlertBadge = createReactComponent('telia-alert-badge');
export const TeliaBadge = createReactComponent('telia-badge');
export const TeliaBannerBillboard = createReactComponent('telia-banner-billboard');
export const TeliaBreadcrumbs = createReactComponent('telia-breadcrumbs');
export const TeliaBreadcrumbsItem = createReactComponent('telia-breadcrumbs-item');
export const TeliaButton = createReactComponent('telia-button');
export const TeliaCardFrame = createReactComponent('telia-card-frame');
export const TeliaCardFrameLink = createReactComponent('telia-card-frame-link');
export const TeliaCheckbox = createReactComponent('telia-checkbox');
export const TeliaChipChoice = createReactComponent('telia-chip-choice');
export const TeliaChipFilter = createReactComponent('telia-chip-filter');
export const TeliaCol = createReactComponent('telia-col');
export const TeliaColorDot = createReactComponent('telia-color-dot');
export const TeliaContentBanner = createReactComponent('telia-content-banner');
export const TeliaCounterBadge = createReactComponent('telia-counter-badge');
export const TeliaCtaLink = createReactComponent('telia-cta-link');
export const TeliaDatePicker = createReactComponent('telia-date-picker');
export const TeliaDivider = createReactComponent('telia-divider');
export const TeliaFieldAssistiveText = createReactComponent('telia-field-assistive-text');
export const TeliaFieldError = createReactComponent('telia-field-error');
export const TeliaFieldValid = createReactComponent('telia-field-valid');
export const TeliaFieldset = createReactComponent('telia-fieldset');
export const TeliaFocusTrap = createReactComponent('telia-focus-trap');
export const TeliaFooter = createReactComponent('telia-footer');
export const TeliaFooterLegal = createReactComponent('telia-footer-legal');
export const TeliaFooterNavigation = createReactComponent('telia-footer-navigation');
export const TeliaFooterPartners = createReactComponent('telia-footer-partners');
export const TeliaForm = createReactComponent('telia-form');
export const TeliaGrid = createReactComponent('telia-grid');
export const TeliaHeading = createReactComponent('telia-heading');
export const TeliaHeroBanner = createReactComponent('telia-hero-banner');
export const TeliaIcon = createReactComponent('telia-icon');
export const TeliaImage = createReactComponent('telia-image');
export const TeliaLabel = createReactComponent('telia-label');
export const TeliaLink = createReactComponent('telia-link');
export const TeliaLinkImage = createReactComponent('telia-link-image');
export const TeliaList = createReactComponent('telia-list');
export const TeliaLogo = createReactComponent('telia-logo');
export const TeliaNavigation = createReactComponent('telia-navigation');
export const TeliaNavigationButton = createReactComponent('telia-navigation-button');
export const TeliaNavigationDropdown = createReactComponent('telia-navigation-dropdown');
export const TeliaNavigationLink = createReactComponent('telia-navigation-link');
export const TeliaNotification = createReactComponent('telia-notification');
export const TeliaOverlay = createReactComponent('telia-overlay');
export const TeliaP = createReactComponent('telia-p');
export const TeliaPictogram = createReactComponent('telia-pictogram');
export const TeliaPrice = createReactComponent('telia-price');
export const TeliaProductCardHardware = createReactComponent('telia-product-card-hardware');
export const TeliaRadioButton = createReactComponent('telia-radio-button');
export const TeliaRow = createReactComponent('telia-row');
export const TeliaSearchInput = createReactComponent('telia-search-input');
export const TeliaSelect = createReactComponent('telia-select');
export const TeliaSkeleton = createReactComponent('telia-skeleton');
export const TeliaSlotGroup = createReactComponent('telia-slot-group');
export const TeliaStatusBadge = createReactComponent('telia-status-badge');
export const TeliaStyleLink = createReactComponent('telia-style-link');
export const TeliaStyleNavigationItem = createReactComponent('telia-style-navigation-item');
export const TeliaTab = createReactComponent('telia-tab');
export const TeliaTabContent = createReactComponent('telia-tab-content');
export const TeliaTabHeader = createReactComponent('telia-tab-header');
export const TeliaTextInput = createReactComponent('telia-text-input');
export const TeliaTextSpacing = createReactComponent('telia-text-spacing');
export const TeliaTextarea = createReactComponent('telia-textarea');
export const TeliaToggle = createReactComponent('telia-toggle');
export const TeliaVideoPlayer = createReactComponent('telia-video-player');
export const TeliaVisuallyHidden = createReactComponent('telia-visually-hidden');
export const TeliaVocaStats = createReactComponent('telia-voca-stats');
export const TeliaVst = createReactComponent('telia-vst');
